import React from 'react'
import { Box, VStack } from '@chakra-ui/react'

export default function AuthPageLayout({ existing }) {
  // Simple centered column keeps sign-in content front and center.
  return (
    <Box w="100%" maxW="640px" px={4} pb={{ base: 12, md: 16 }}>
      <VStack align="stretch" spacing={6}>
        {existing}
      </VStack>
    </Box>
  )
}
